import { StytchB2B } from '@stytch/react/b2b'
import { AuthFlowType, B2BProducts } from '@stytch/vanilla-js/b2b'
import MarketingLayout from '@/layouts/MarketingLayout'

const config = {
  authFlowType: AuthFlowType.Discovery,
  products: [B2BProducts.emailMagicLinks],
  emailMagicLinksOptions: {
    discoveryRedirectURL: `${window.location.origin}/authenticate`,
  },
  sessionOptions: {
    sessionDurationMinutes: 525600, // 1 year
  },
}

function Login() {
  return (
    <div className="mx-auto max-w-sm pt-12">
      <StytchB2B config={config} />
    </div>
  )
}

Login.layout = (page: React.ReactNode) => <MarketingLayout>{page}</MarketingLayout>

export default Login
